// システム設定モジュール ページ国際化

export default {
  // ─── 更新履歴 ────────────────────────────────────────────────────────────────
  'system.changelog.type.feature': '新機能',
  'system.changelog.type.improve': '改善',
  'system.changelog.type.fix': '修正',
  'system.changelog.type.breaking': '重要',
  'system.changelog.tag.latest': '最新',
  'system.changelog.tag.current': '現在',

  // ─── グローバル設定 ──────────────────────────────────────────────────────────
  'system.config.save': '保存',

  // パスワードポリシー
  'system.config.pwd.tab': 'パスワードポリシー',
  'system.config.pwd.title': 'パスワードポリシー',
  'system.config.pwd.desc': 'ユーザーパスワードの変更サイクルを設定します',
  'system.config.pwd.expireDays.label': 'パスワード有効期限（日）',
  'system.config.pwd.expireDays.tooltip': 'ユーザーはこの期間内にパスワードを変更する必要があります。0 に設定すると無制限になります。',
  'system.config.pwd.expireDays.required': '日数を入力してください',
  'system.config.pwd.maxError.label': 'パスワード最大エラー回数',
  'system.config.pwd.maxError.tooltip': '統計時間ウィンドウ内でこの回数を超えて連続してパスワードを間違えると、アカウントが無効になります。0 に設定すると無制限になります。',
  'system.config.pwd.maxError.required': '最大エラー回数を入力してください',
  'system.config.pwd.errorWindow.label': 'エラー回数統計時間ウィンドウ（時間）',
  'system.config.pwd.errorWindow.tooltip': 'この時間ウィンドウ内で累積エラー回数が上限に達するとアカウントが無効になります。0 に設定すると無制限になります。',
  'system.config.pwd.errorWindow.required': '時間ウィンドウの時間数を入力してください',
  'system.config.pwd.save.success': 'パスワードポリシーを保存しました',

  // メール設定
  'system.config.email.tab': 'メール設定',
  'system.config.email.title': 'メール設定',
  'system.config.email.desc': 'システム通知メールの送信方式（SMTP または Postmark API）を設定します',
  'system.config.email.sendType.label': '送信方式',
  'system.config.email.sendType.smtp': 'SMTP',
  'system.config.email.sendType.postmark': 'Postmark API',
  'system.config.email.sendType.required': '送信方式を選択してください',
  'system.config.email.host.label': 'SMTP サーバー',
  'system.config.email.host.required': 'SMTP サーバーアドレスを入力してください',
  'system.config.email.port.label': 'ポート',
  'system.config.email.port.required': 'ポートを入力してください',
  'system.config.email.encrypt.label': '暗号化方式',
  'system.config.email.encrypt.required': '暗号化方式を選択してください',
  'system.config.email.encrypt.placeholder': '選択してください',
  'system.config.email.username.label': 'アカウント',
  'system.config.email.username.required': 'アカウントを入力してください',
  'system.config.email.username.placeholder': 'メールアカウント',
  'system.config.email.fromEmail.label': '送信者メールアドレス',
  'system.config.email.fromEmail.required': '送信者メールアドレスを入力してください',
  'system.config.email.fromEmail.invalid': '有効なメールアドレスを入力してください',
  'system.config.email.fromName.label': '送信者名',
  'system.config.email.fromName.required': '送信者名を入力してください',
  'system.config.email.fromName.placeholder': '例：システム通知',
  'system.config.email.authCode.label': '認証コード',
  'system.config.email.authCode.required': 'メール認証コードを入力してください',
  'system.config.email.authCode.placeholder': 'メール認証コードまたはアプリ専用パスワード',
  'system.config.email.save.success': 'メール設定を保存しました',

  // メールテンプレート
  'system.config.template.tab': 'メールテンプレート',
  'system.config.template.add.title': '新規ユーザーメールテンプレート',
  'system.config.template.add.desc': "新規ユーザー追加時に送信するメール内容を設定します。変数 '{userAccount}'、'{password}' をサポートしています。",
  'system.config.template.reset.title': 'パスワードリセットメールテンプレート',
  'system.config.template.reset.desc': "ユーザーがパスワードをリセットする際に送信するメール内容を設定します。変数 '{userAccount}'、'{resetLink}' をサポートしています。",
  'system.config.template.subject.label': 'メール件名',
  'system.config.template.subject.required': 'メール件名を入力してください',
  'system.config.template.content.label': 'メールテンプレート内容',
  'system.config.template.content.required': 'メールテンプレート内容を入力してください',
  'system.config.template.content.extra': '改行に対応しています。Enter キーで段落を区切ると、送信時に段落形式が自動的に保持されます。',
  'system.config.template.add.save.success': 'メールテンプレートを保存しました',
  'system.config.template.reset.save.success': 'パスワードリセットメールテンプレートを保存しました',
  'system.config.template.forget.title': 'パスワード忘れメールテンプレート',
  'system.config.template.forget.title.placeholder': '例：パスワードを忘れたメール',
  'system.config.template.forget.desc': "ユーザーがパスワードを忘れた際に送信するメール内容を設定します。変数 '{authCode}' をサポートしています。",
  'system.config.template.forget.desc.placeholder': "パスワード再設定ボタンをクリックしてください http://example.com?authCode='{authCode}'、15分以内有効",
  'system.config.template.forget.content.extra': "改行に対応しています。Enter キーで段落を区切ると、送信時に段落形式が自動的に保持されます。変数 '{authCode}' を使用できます。",
  'system.config.template.forget.save.success': 'パスワード忘れメールテンプレートを保存しました',

  // ファイルアップロード設定
  'system.config.storage.tab': 'ファイルアップロード設定',
  'system.config.storage.title': 'アップロード容量設定',
  'system.config.storage.desc': '個人・会社・テナント全体のファイルアップロード容量上限を設定します。0 は無制限を意味します。',
  'system.config.storage.user.label': '個人容量上限（MB）',
  'system.config.storage.user.tooltip': '各ユーザーがアップロードできる総ファイル量。0 に設定すると無制限になります。',
  'system.config.storage.user.required': '個人容量上限を入力してください',
  'system.config.storage.company.label': '会社容量上限（MB）',
  'system.config.storage.company.tooltip': '各会社の全ユーザーがアップロードできる総ファイル量。0 に設定すると無制限になります。',
  'system.config.storage.company.required': '会社容量上限を入力してください',
  'system.config.storage.tenant.label': 'テナント全体容量上限（MB）',
  'system.config.storage.tenant.tooltip': 'このテナント下の全会社のファイルアップロード総量の上限。0 に設定すると無制限になります。',
  'system.config.storage.tenant.required': 'テナント容量上限を入力してください',
  'system.config.storage.save.success': 'アップロード容量設定を保存しました',

  // ─── アプリ情報 ──────────────────────────────────────────────────────────────
  'system.info.version.title': 'バージョン情報',
  'system.info.version.current': '現在のバージョン',
  'system.info.version.latest': '最新バージョン',
  'system.info.version.build': 'ビルドバージョン',
  'system.info.version.serviceStatus': 'サービス状態',
  'system.info.version.status.ok': '正常稼働中',
  'system.info.version.status.error': '異常発生',
  'system.info.update.title': 'システム更新',
  'system.info.update.hasNew': '新バージョンあり',
  'system.info.update.desc': '使用前に設定が必要です',
  'system.info.update.btn': 'ソフトウェア更新を設定',
  'system.info.client.title': 'クライアントアドレス',
  'system.info.client.desc': 'クライアントは管理ポータルとクライアントポータルをサポートしています',
  'system.info.client.btn': 'クライアントへ移動',
  'system.info.docs.title': 'ヘルプドキュメント',
  'system.info.docs.desc': '完全な製品ドキュメントを参照して、各機能の使い方を確認してください',
  'system.info.docs.btn': 'ドキュメントを見る',
  'system.info.docker.title': 'Docker イメージ',
  'system.info.docker.desc': 'バックエンドシステムは Docker イメージでリリースされています。最新バージョンを確認してください。',
  'system.info.docker.btn': 'Docker Hub',

  // ─── ライセンス管理 ──────────────────────────────────────────────────────────
  'system.license.status.valid': '有効',
  'system.license.status.invalid': '無効',
  'system.license.status.expired': '期限切れ',
  'system.license.authorized': 'システム認証済み',
  'system.license.unauthorized': 'システム未認証',
  'system.license.authorizedDesc': '現在のシステムには有効な License 認証があります。',
  'system.license.unauthorizedDesc': '現在のシステムには有効な認証がありません。管理者に連絡して License を取得してください。',
  'system.license.statusLabel': '認証状態',
  'system.license.running': '正常稼働中',
  'system.license.notAuthorized': '未認証',
  'system.license.info.title': '現在の License 情報',
  'system.license.info.desc': '現在のシステムの License 認証状態を表示します',
  'system.license.field.activateTime': 'アクティベート日時',
  'system.license.field.expireTime': '有効期限',
  'system.license.field.status': '状態',
  'system.license.field.company': '会社名',
  'system.license.field.userLimit': 'ユーザー制限',
  'system.license.field.features': '認証機能',
  'system.license.expireSoon': '間もなく期限切れ',
  'system.license.refresh': 'クリックして認証情報を更新',

  // ─── メニュー設定 ────────────────────────────────────────────────────────────
  'system.menu.title': 'メニュー設定',
  'system.menu.empty': 'メニューなし',
  'system.menu.save': '変更を保存',
  'system.menu.sort.success': '並び順を保存しました',
  'system.menu.sort.fail': '並び順の保存に失敗しました',
  'system.menu.detail.empty': '左側のメニューを選択して詳細を表示してください',
  'system.menu.form.basicInfo': '基本情報',
  'system.menu.form.configSettings': '設定',
  'system.menu.form.name.label': 'メニュー名',
  'system.menu.form.name.placeholder': '空欄でデフォルト',
  'system.menu.form.name.required': 'メニュー名を入力してください',
  'system.menu.form.name.tooltip': 'メニューのカスタム表示名。言語別に設定でき、空欄ならその言語のシステム既定の翻訳を使用します。',
  'system.menu.form.path.label': 'ルートパス',
  'system.menu.form.path.placeholder': 'ルートパスを入力してください',
  'system.menu.form.path.tooltip': '対応するフロントエンドのルートパス（一意の識別子）',
  'system.menu.form.icon.label': 'メニューアイコン',
  'system.menu.form.icon.tooltip': 'メニューの左側に表示されるアイコン',
  'system.menu.form.sort.label': '並び順',
  'system.menu.form.sort.tooltip': 'メニューの表示順序',
  'system.menu.form.remark.label': '備考',
  'system.menu.form.remark.placeholder': '備考を入力してください',
  'system.menu.tree.button': 'ボタン',
  'system.menu.tree.disabled': '無効',

  // ─── 更新履歴 エントリ ────────────────────────────────────────────────────────
  // v0.0.8
  'system.changelog.v008.item0': 'Token消費統計とクォータ管理を追加（入口：ユーザー管理 > クォータ、会社管理 > クォータ）',
  'system.changelog.v008.item1': 'ユーザー管理にExcel一括インポートを追加、ユーザーの一括作成をサポート',
  'system.changelog.v008.item2': 'ワークスペース / アプリ総合クエリパネルを追加',
  'system.changelog.v008.item3': 'システム設定モジュールを追加：グローバル設定 / ライセンス管理 / 更新履歴 / アプリ情報',
  'system.changelog.v008.item4': 'グローバル検索ボックスにあいまい検索を追加（データ量が多いため操作ログを除く）',
  'system.changelog.v008.item5': '一部のリストにステータスクイックフィルターを追加',
  'system.changelog.v008.item6': 'ユーザー登録メール通知とメールテンプレート設定を追加',
  'system.changelog.v008.item7': 'グローバルリストにフィールドソート機能を追加',
  'system.changelog.v008.item8': 'リストフィールドのカスタマイズ、ローカル保存、エクスポートレポートフィールドの同期を最適化',
  'system.changelog.v008.item9': 'サイドバーメニューの折りたたみ・展開ロジックを最適化',
  'system.changelog.v008.item10': '一部ページのインタラクション体験を最適化',
  // v0.0.7
  'system.changelog.v007.item0': 'アプリToken消費ランキングを追加、アプリ・会社・ユーザー軸での確認をサポート',
  'system.changelog.v007.item1': 'すべてのメニューの並び順切替と全検索フィールドのあいまい検索を追加',
  'system.changelog.v007.item2': 'メニュー国際化キャッシュ処理ロジックを最適化、言語切替速度を向上',
  'system.changelog.v007.item3': 'アプリ分析モジュールをリファクタリング、廃止済みモックデータコンポーネントを削除',
  'system.changelog.v007.item4': 'マルチユーザー環境でのアプリキャッシュデータ混用問題を修正',
};
